import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findMotorCreditoFormula from '../../service/findMotorCreditoFormula';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';




export default function MotorCreditoFormulaList({onEdit}:{onEdit:(motorCreditoFormula:any)=>void}) {
  const { t } = useTranslation();
  const [formulas, setFormulas] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: 'descricao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findMotorCreditoFormula(lazyState).then(data => {setTotalRecords(data.total);setFormulas(data.formulas)}).catch(() => {setTotalRecords(0);setFormulas(undefined)});
  }

  const editBodyTemplate = (servico:any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(servico)} style={{background:'transparent', color:'gray', border: 'none'}} />;
  };
  
  useEffect(() => {
    loadLazyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lazyState])

  return (
    <div>
      <div>
        <DataTable value={formulas} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="descricao"  header={t('descricao')}  />
           <Column body={(item)=> item.dadoManual ? 'Sim' : 'Não'} header={t('dadoManual')}  />
           <Column field="idPermissao"  header={t('opcao')}  />
           <Column field="localizacao" sortable header={t('localizacao')}  />
           <Column body={editBodyTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


